import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const posSentimentResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  let posSentiment
  if (widgetType && widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    posSentiment = metadata.getPosSentiment()
  }

  return { posSentiment } as StreamData
}

export default posSentimentResolver
